module.exports = __webpack_public_path__ + "static/metrics-card-2-fe5ca1f11b59f4d2f0670450594d81c9.png";